import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import H5 from '@base/H5/H5';
import Paper from '@base/Paper/Paper';
import { Spacings, mediaQuery } from '@styles/index';
import pushRoute from '@utils/pushRoute';
import Button from '@base/Button/Button';
import { openToggleableElement } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';
import EducatorAvatar from './EducatorAvatar';
import { getModifiedAttempCount } from './utils';

const Wrapper = styled(Paper)`
  width: 272px;
  height: 264px;
  padding: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: auto;
  }
`;

const ProfileContainer = styled.div`
  width: ${Spacings.SPACING_20B};
  height: ${Spacings.SPACING_20B};
  display: grid;
  place-items: center;
`;

const ProfileInfo = styled.div`
  margin-top: ${Spacings.SPACING_3B};
`;

const StyledP1 = styled(P1)`
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_1B};
  line-height: ${Spacings.SPACING_5B};
`;

const StyledH5 = styled(H5)`
  line-height: ${Spacings.SPACING_5B};
`;

const StyledButton = styled(Button)`
  width: 224px;
  margin-top: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const DPPCard = ({ info }) => {
  const educatorInfo = info.educatorDetailsJson;
  const attemptCount = getModifiedAttempCount(info.attemptCount);
  const name = `${educatorInfo.firstName} ${educatorInfo.lastName}`;

  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);

  const handleOnClick = () => {
    // Check if user is logged in
    if (!isLoggedIn) {
      openToggleableElement(LOGIN_DRAWER);
      return;
    }

    pushRoute(
      '/[authorID]?view=Practice',
      `/@${educatorInfo.username}?view=Practice`
    );
  };

  return (
    <Wrapper>
      <ProfileContainer>
        <EducatorAvatar
          isLarge
          url={educatorInfo.avatar}
          badge={educatorInfo.badge}
        />
      </ProfileContainer>
      <ProfileInfo>
        <StyledH5>{name}</StyledH5>
        <StyledP1>{educatorInfo.subject}</StyledP1>
        <StyledP1>{attemptCount} learners attempted</StyledP1>
      </ProfileInfo>
      <StyledButton
        label="View practices"
        variant="hollow"
        color="black"
        maxHeight="sm"
        onClick={handleOnClick}
      />
    </Wrapper>
  );
};

export default DPPCard;
